import cx from 'classnames';
import { isUndefined } from 'lodash';
import { Icon } from 'components/Icon';
import { Heading } from 'components/Typography';
import { useDisplayTimezone } from 'domains/timezone/useDisplayTimezone';
import { DATE_LONG_DAY_MONTH_YEAR, TIME_ONLY } from 'utils/date';

type Props = {
  date: Date;
  className?: string;
  dateSuffix?: string;
};
export const AppointmentDate: React.FC<Props> = ({ date, className, dateSuffix }) => {
  const { format, displayTimezone } = useDisplayTimezone();

  if (isUndefined(displayTimezone)) {
    throw new Error('Undefined display timezone when confirming appointment date');
  }

  return (
    <div className={cx('flex flex-col gap-8', className)}>
      <div className="flex gap-16 items-center">
        <Icon name="Calendar" className="w-24 p-2 shrink-0" />
        <Heading level="h5" className="font-medium">
          {format(date, DATE_LONG_DAY_MONTH_YEAR)} {dateSuffix}
        </Heading>
      </div>
      <div className="flex gap-16 items-center">
        <Icon name="Clock" className="w-24 p-2 shrink-0" />
        <Heading level="h5" className="font-medium">
          {`${format(date, TIME_ONLY)} ${displayTimezone.label}`}
        </Heading>
      </div>
    </div>
  );
};
